var _path, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradiantSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3784 0C26.6838 0 30.4589 2.26791 32.5762 5.67378L30.7341 7.01351C29.0351 4.17267 25.9291 2.27027 22.3784 2.27027C17.0048 2.27027 12.6487 6.62642 12.6487 12C12.6487 17.3736 17.0048 21.7297 22.3784 21.7297C26.7349 21.7297 30.4224 18.8663 31.6621 14.9189H24.6486V12.3243H35.027V22.7027H32.4324V18.5517C30.2906 21.8318 26.588 24 22.3784 24C15.751 24 10.3784 18.6274 10.3784 12C10.3784 5.37258 15.751 0 22.3784 0Z",
    fill: "#202A2C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.2162,
    cy: 4.21622,
    rx: 4.2162,
    ry: 4.21622,
    fill: "#2D545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradiantSmall);
export default __webpack_public_path__ + "static/media/gradiantSmall.b1621c5c841c5d72b1bc5ab57c1d269b.svg";
export { ForwardRef as ReactComponent };